import type React from 'react';
import { useRef } from 'react';
import { WarningFilled } from '@ant-design/icons';
import { BaseAlertBanner } from '@components';
import { useLingui } from '@lingui/react/macro';
import {
    CertificatePreviewFrame,
    CertificatePreviewPageWrapper as Wrapper,
} from '@routes/sidebar/admin-center/creator/___pages___/pathways/styled.tsx';

export const CertificatePreview: React.FC = () => {
    const { t } = useLingui();
    const iframeRef = useRef<HTMLIFrameElement>(null);

    const handleIframeLoad = () => {
        const iframe = iframeRef.current;
        const iframeWindow = iframe?.contentWindow;
        const iframeDocument = iframe?.contentDocument;

        if (!iframe || !iframeWindow || !iframeDocument) return;

        // Adjust iframe height to fit the scaled certificate content without clipping or internal scrolling.
        const updateHeight = () => {
            const certificate = iframeDocument.getElementById('certificate-preview');

            if (certificate) {
                iframe.style.height = `${Math.ceil(certificate.getBoundingClientRect().height)}px`;
            }
        };

        updateHeight();
        iframeWindow.addEventListener('resize', updateHeight);
    };

    return (
        <Wrapper>
            <BaseAlertBanner
                type="warning"
                title={t`Certificate Preview Mode`}
                description={t`You are viewing a sample certificate.`}
                icon={<WarningFilled />}
            />
            <CertificatePreviewFrame
                ref={iframeRef}
                src={`${import.meta.env.BASE_URL}templates/certificate-preview.html`}
                title="Certificate preview"
                onLoad={handleIframeLoad}
            />
        </Wrapper>
    );
};
